import { RouteRecordRaw } from 'vue-router';
import { SectionRouteNames } from './sectionRouteNames.ts';

export const networksRoutes: Record<string, RouteRecordRaw> = {
    home: {
        path: '',
        name: `${SectionRouteNames.networks}Home`,
        components: {
            default: () => import('@/views/sectionViews/networks/NetworksHomeView.vue'),
        },
        meta: {
            headName: 'Networks Home',
            displayTitle: 'Home',
        },
    },
};
